import { render } from "./Sorting.vue?vue&type=template&id=90e29c0c&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"

import "./Sorting.vue?vue&type=style&index=0&id=90e29c0c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e29c0c"]])

export default __exports__